import { connect } from 'react-redux';
import { AppState } from '../../redux/store';
import { selectAuthData } from '../../redux/selectors/auth';
import { PermissionsProvider } from './Permissions';

const mapStateToProps = (state: AppState) => ({
  userRoleId: selectAuthData(state).userRoleId,
});

export default connect(mapStateToProps)(PermissionsProvider);
